import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import React, { Component } from 'react';
import RankingRuleForm from './Form';

const styles = {
  uuid: {
    fontFamily: 'monospace',
    color: 'rgba(0, 0, 0, 0.54)',
  },
};

@withStyles(styles)
export default class Row extends Component {
  handleChange = rankingRule => this.props.update(rankingRule);

  render() {
    const { tableData, classes } = this.props;
    const { name, metaImportUuid } = tableData;

    return (
      <TableRow>
        <TableCell>{name}</TableCell>
        <TableCell>
          <RankingRuleForm onSubmit={this.handleChange} data={tableData} />
        </TableCell>
        <TableCell className={classes.uuid}>{metaImportUuid}</TableCell>
      </TableRow>
    );
  }
}
